import { API_URL, SOCKET_URL } from "./env";

/**
 * Where socket.io lives: VITE_SOCKET_URL if set, else the API's server without /api, else
 * this page's own host (localhost:5000 in development).
 */
export function socketUrl() {
  let url = null;

  // Check for dedicated socket URL first (optional, for production)
  if (SOCKET_URL) {
    url = SOCKET_URL.replace(/\/$/, "");
    try {
      new URL(url);
    } catch (e) {
      console.error("Invalid VITE_SOCKET_URL format:", SOCKET_URL);
      url = null;
    }
  }

  // If no dedicated socket URL, derive from API URL
  if (!url && API_URL) {
    try {
      // Remove trailing /api if present, and any trailing slash
      const apiUrl = API_URL.trim().replace(/\/api\/?$/, "").replace(/\/$/, "");
      new URL(apiUrl);
      url = apiUrl;
    } catch (e) {
      console.error("Invalid VITE_API_URL format:", API_URL);
      url = null;
    }
  }

  // Fallback: use window location in production, localhost in development
  if (!url) {
    if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
      const protocol = window.location.protocol === "https:" ? "https:" : "http:";
      url = `${protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;
    } else {
      url = "http://localhost:5000";
    }
  }

  return url;
}
